module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-eight.20630ddf.png";